import { useTranslation } from 'react-i18next';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  cn,
} from '@erp/ui';
import { Sun, Moon, Laptop, Check } from '@/components/icons';
import { useBrandTheme } from '@/lib/brand-theme-provider';
import type { ThemeMode } from '@erp/config';

export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { mode, setMode, resolvedMode } = useBrandTheme();

  const options: { value: ThemeMode; labelKey: string; Icon: typeof Sun }[] = [
    { value: 'light', labelKey: 'theme.light', Icon: Sun },
    { value: 'dark', labelKey: 'theme.dark', Icon: Moon },
    { value: 'system', labelKey: 'theme.system', Icon: Laptop },
  ];

  const ActiveIcon = resolvedMode === 'dark' ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t('theme.toggle')}
          // Mobile: 36 px tap target. Desktop: keeps the compact 28 px size-7.
          className={cn('size-9 md:size-7', className)}
        >
          <ActiveIcon size={18} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem]">
        {options.map(({ value, labelKey, Icon }) => (
          <DropdownMenuItem
            key={value}
            onClick={() => setMode(value)}
            className="gap-2"
          >
            <Icon size={16} />
            <span className="flex-1">{t(labelKey)}</span>
            {mode === value && <Check size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
